import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef, useContext } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import '../../styles/game/GameBoard.css';
import { MenuButtons } from '../../providers/MenuButtonsContext.jsx';
import { useData, useSocket } from '../../providers/SocketContext.jsx'

import BgSun from './gameboard_components/BgSun.jsx';
import DataMultiplier from "./gameboard_components/DataMultiplier";
import Blur from "./gameboard_components/Blur";
import ViewResults from "./gameboard_components/ViewResults";
import Dots from "./gameboard_components/Dots";
import DotsBottom from "./gameboard_components/DotsBottom.jsx"
import Aviator from "./gameboard_components/Aviator";
import Countdown from "./gameboard_components/Countdown";
import { useAuth } from "../../providers/AuthProvider.jsx";
function GameBoard({ chatBar, online }) {
    const socket = useSocket()
    const user = useAuth()
    const [isRotating, setIsRotating] = useState(false); // Состояние управления анимацией
    const { isSoundOn, setIsSoundOn, isMusicOn, setIsMusicOn, isAnimationOn, setIsAnimationOn } = useContext(MenuButtons)
    const [isGameState, setIsGameState] = useState(null);
    const [countdownState, setCountdownState] = useState(null)
    const [playersAvatar, setPLayersAvatar] = useState([5, 15, 23])
    const [singlePlayersCount, setSinglePlayersCount] = useState(0)
    useEffect(() => {
        if(!socket) {
            return
        }

        if(!user) {
            return
        }
       
        socket.on('connect', () => {
            socket.emit('get_gameState')
            // socket.emit('login', user.user.id)
            socket.emit('get_rounds_results')
        })

        socket.on('set_gameState', (res, countdown) => {
            setCountdownState(countdown)
            setIsGameState(res)
            // console.log(res + ' GAME STATE')
            // console.log('COUNTDOWN        ' + countdown)
        })

        return () => {
            socket.off('connect');
            socket.off('set_gameState');
        }
    }, [socket, user])

    useEffect(() => {
        if(!socket) {
            return
        }

        socket.on('gameState', (res) => {
            setIsGameState(res)
            
        })

        socket.on('countdownState', (res) => {
            const parse = parseFloat(res)
            setCountdownState(parse)
            // console.log(res + '     IN GAMEBOARD')
        })

        return () => {
            socket.off('gameState');
            socket.off('countdownState');
        }
    }, [socket])


    useEffect(() => {
        if(!socket) {
            return
        }

        socket.emit('game_board_single_players_emit')
        socket.on('game_board_get_single_players', (singlePlayers) => {
            setSinglePlayersCount(singlePlayers)
        })

        return () => {
            socket.off('game_board_get_single_players', (singlePlayers) => {
                setSinglePlayersCount(singlePlayers)
            })
        }
    }, [socket])

    useEffect(() => {
        if(!socket) {
            return
        }

        socket.on('get_single_players_game_board', (res) => {
            setSinglePlayersCount(parseFloat(res))
        })

        socket.on('single_players_update', (res) => {
            setSinglePlayersCount(parseFloat(res))
        })

        socket.on('players_avatar_emit_gameboard', (res) => {
            setPLayersAvatar(res)
        })

        return () => {
            socket.off('get_single_players_game_board', (res) => {
                setSinglePlayersCount(parseFloat(res))
            })
            socket.off('single_players_update', (res) => {
                setSinglePlayersCount(parseFloat(res))
            })
            socket.off('players_avatar_emit_gameboard', (res) => {
                setPLayersAvatar(res)
            })
        }
    }, [socket])
    

    useEffect(() => {
        setIsRotating(() => {
            if(isGameState === 'active') {
                return true
            } else {
                return false
            }
        })
        // console.log(isGameState)
    }, [isGameState])


    return (
        <>
            <div className={"game-board-wrapper"} style={{ border: '1px solid #2a2b2e', borderRadius: '18px',}}>
                <BgSun isRotating={isRotating} isAnimationOn={isAnimationOn} />
                <Blur isGameState={isGameState}/>
                <div className={`dotsWrapperContainer ${isAnimationOn ? "show" : ""}`}>
                {/* {isGameState === 'active' && <Dots/>}
                {isGameState === 'active' && <DotsBottom/>} */}
                </div>
                <Aviator isGameState={isGameState} chatBar={chatBar} />
                {isGameState === 'active' && <DataMultiplier isGameState={isGameState} />}
                {<ViewResults />}
                {isGameState === 'countdown' && <Countdown isGameState={isGameState} chatBar={chatBar} />}
                {singlePlayersCount && <div className={'game-board-avatars-wrapper'}>
                    <div className={'game-board-avatars-container'}>
                        <img className={'all-bets-block-avatar-wrap-1'} src={`/assets/img/avatars/av-${playersAvatar[0]}.png`} alt="" />
                        <img className={'all-bets-block-avatar-wrap-2'} src={`/assets/img/avatars/av-${playersAvatar[1]}.png`} alt="" />
                        <img className={'all-bets-block-avatar-wrap-3'} src={`/assets/img/avatars/av-${playersAvatar[2]}.png`} alt="" />
                    </div>
                    <div className={'game-board-players-count-wrap'}>
                        {singlePlayersCount ? parseFloat(singlePlayersCount).toFixed(0) : 0}
                    </div>
                </div>}
            </div>
        </>
    )
}

export default GameBoard;